import { SearchInactiveFoliosResponseType } from '../../components/quick-links/InactiveFolios/SearchPage/types';
import {
    GetInactiveFoliosRequestType,
    GetInactiveFoliosResponseType,
} from '../../components/quick-links/InactiveFolios/types';
import { CALL_API } from '../middleware';
import {
    AMFI_CAS_API,
    DORMANT_PAN_CHECK,
    DORMANT_PAN_CHECK_SUCCESS,
    GET_AMFI_CAS,
    GET_AMFI_CAS_SUCCESS,
    GET_ATTEMPTS_LEFT,
    GET_ATTEMPTS_LEFT_SUCCESS,
    GET_INACTIVE_FOLIOS,
    GET_INACTIVE_FOLIOS_SUCCESS,
    PAN_FUNDS,
    PAN_FUNDS_SUCCESS,
    PRE_LOGIN_TRANSMISSION,
    PRE_LOGIN_TRANSMISSION_SUCCESS,
    REGISTER_DORMANT,
    REGISTER_DORMANT_SUCCESS,
    SEARCH_INACTIVE_FOLIOS,
    SEARCH_INACTIVE_FOLIOS_SUCCESS,
    VERIFY_DORMANT,
    VERIFY_DORMANT_SUCCESS,
} from '../types/links';

export const getPanFundDetails = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/getPreLoginFolios',
                method: 'POST',
                types: [PAN_FUNDS_SUCCESS, PAN_FUNDS],
                body,
                // enableFixture: true,
                json: `panDetails.json`,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const getCountries = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/link/getCountries',
                method: 'POST',
                types: [PAN_FUNDS_SUCCESS, PAN_FUNDS],
                body,
                enableFixture: true,
                json: `default-countries.json`,
                enableForProduction: true,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const collectDetailsForPreloginTransmission = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/nft/collectDetailsForPreloginTransmission',
                method: 'POST',
                types: [PRE_LOGIN_TRANSMISSION_SUCCESS, PRE_LOGIN_TRANSMISSION],
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const transmissionOfUnitsPreLogin = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/nft/transmissionOfUnitsPreLogin',
                method: 'POST',
                types: [PRE_LOGIN_TRANSMISSION_SUCCESS, PRE_LOGIN_TRANSMISSION],
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const transmissionPdf = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/nft/transmissionPdf',
                method: 'POST',
                types: [PRE_LOGIN_TRANSMISSION_SUCCESS, PRE_LOGIN_TRANSMISSION],
                contentType: 'application/pdf',
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const dormantPanCheck = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/dormantPanCheck',
                method: 'POST',
                types: [DORMANT_PAN_CHECK_SUCCESS, DORMANT_PAN_CHECK],
                // enableFixture: true,
                json: `dormantPanCheck.json`,
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const registerDormantOtp = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/registerDormantOtp',
                method: 'POST',
                types: [REGISTER_DORMANT_SUCCESS, REGISTER_DORMANT],
                // enableFixture: true,
                json: `dormantRegisterOtp.json`,
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const getInactiveFolios =
    (body: GetInactiveFoliosRequestType) =>
    async (dispatch: any): Promise<GetInactiveFoliosResponseType> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getInActiveFolios',
                    method: 'POST',
                    types: [GET_INACTIVE_FOLIOS_SUCCESS, GET_INACTIVE_FOLIOS],
                    // enableFixture: true,
                    json: `getInactiveFolios.json`,
                    body,
                },
            });
        } catch (err: any) {
            throw err;
        }
    };

export const searchInactiveFolios =
    (body: any) =>
    async (dispatch: any): Promise<SearchInactiveFoliosResponseType> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/searchInActiveFolios',
                    method: 'POST',
                    types: [SEARCH_INACTIVE_FOLIOS_SUCCESS, SEARCH_INACTIVE_FOLIOS],
                    // enableFixture: true,
                    json: `searchInactiveFolios.json`,
                    body,
                },
            });
        } catch (err: any) {
            throw err;
        }
    };

export const getAttemptsLeft =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getAttemptsLeft',
                    method: 'POST',
                    types: [GET_ATTEMPTS_LEFT_SUCCESS, GET_ATTEMPTS_LEFT],
                    // enableFixture: true,
                    // json: `searchInactiveFolios.json`,
                    body,
                },
            });
        } catch (err: any) {
            throw err;
        }
    };

export const verifyDormantOtp = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/verifyDormantOtp',
                method: 'POST',
                types: [VERIFY_DORMANT_SUCCESS, VERIFY_DORMANT],
                // enableFixture: true,
                json: `dormantVerifyOtp.json`,
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const validatePanForAmfiCas= (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: AMFI_CAS_API,
                method: 'POST',
                types: [GET_AMFI_CAS_SUCCESS, GET_AMFI_CAS],
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};